import { formatHelper } from "helper/format";
import _get from "lodash.get";
import { readCkycVerificationFromDetails } from "helper/kycDocumentUpload";

const jarvisPrimeOnboardingParser = {};

jarvisPrimeOnboardingParser.brokerList = (res) => {
  if (res && res.data) {
    res = res.data;
  }
  if (!res) {
    return [];
  }

  res.list = res.list.map((p) => ({
    brokerId: _get(p, "brokerId", null),
    brokerName: _get(p, "brokerName", null),
    brokerDisplayName: _get(p, "brokerDisplayName", null),
    brokerPlatform: _get(p, "brokerPlatform", null),
    brokerIcon: formatHelper.getLegacyImageURI(_get(p, "brokerIcon", null)),
    brokerCode: _get(p, "brokerCode", null),
  }));

  res.records = _get(res, "records", 0);
  return res;
};

jarvisPrimeOnboardingParser.rmsPlanList = (res) => {
  let data = {};
  if (res && res.response) {
    res = res.response;
  }
  if (!res) {
    return {};
  }

  const productMap = (product) =>
    product.map((p) => ({
      productCode: _get(p, "productCode", null),
      productName: _get(p, "productName", null),
      productDescription: _get(p, "productDescription", null),
      stockLimit: _get(p, "stockLimit", null),
      primeLimit: _get(p, "primeLimit", null),
      aumLimit: _get(p, "aumLimit", null),
    }));

  const options = (op) =>
    op.map((o) => ({
      planId: _get(o, "planId", null),
      planName: _get(o, "planName", null),
      planCode: _get(o, "planCode", null),
      planChecklist: _get(o, "planChecklist", []),
      planDiscountPercentage: _get(o, "planDiscountPercentage", null),
      planFrequency: _get(o, "planFrequency", null),
      planSequence: _get(o, "planSequence", null),
      planPrice: _get(o, "planPrice", null),
      planFrequencyLabel: _get(o, "planFrequencyLabel", null),
      planDiscountPrice: _get(o, "planDiscountPrice", null),
      planDiscountedPrice: _get(o, "planDiscountedPrice", null),
      tagLabel: _get(o, "tagLabel", null),
      tagColor: _get(o, "tagColor", null),
      tagBackgroundColor: _get(o, "tagBackgroundColor", null),
      productMap: productMap(_get(o, "productMap", [])),
      planPriceType: _get(o, "planPriceType", null),
    }));

  Object.keys(res).forEach((k) => {
    data[k] = options(res[k]);
  });

  return data;
};

jarvisPrimeOnboardingParser.primeOnboardingData = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }
  return {
    // currentStage: _get(res, "currentOnboardingStage", null),
    currentStagePrime: _get(res, "currentStagePrime", null),
    isPrimeOnboardingCompleted: _get(res, "isPrimeOnboardingCompleted", null),
    riskProfileId: _get(res, "riskProfileId", null),
    riskProfileName: _get(res, "riskProfileName", null),
    panNumber: _get(res, "panNumber", null),
    dateOfBirth: _get(res, "dateOfBirth", null),
    aadharNumber:
      _get(res, "aadharNumber", null) || _get(res, "aadhaarNumber", null),
    isManualKYC: _get(res, "isManualKYC", null),
    isPanUploaded: _get(res, "isPanUploaded", null),
    isAadhaarFrontUploaded: _get(res, "isAadhaarFrontUploaded", null),
    isAadhaarBackUploaded:
      _get(res, "isAadhaarBackUploaded", null) ||
      _get(res, "isAadharBackUploaded", null) ||
      _get(res, "aadharCardBackUploaded", null) ||
      _get(res, "aadhaarCardBackUploaded", null),
    documentStatus: _get(res, "documentStatus", null),
    ...readCkycVerificationFromDetails(res),
    duplicateStages: _get(res, "duplicateStages", null),
    primeId: _get(res, "tempCustomerPrimeId", null),
    riskMasterId: _get(res, "riskMasterId", null),
    riskProfileName: _get(res, "riskProfile", null),
    suggestedRiskId: _get(res, "suggestedRiskId", null),
    investmentAmount: _get(res, "investmentAmount", null),
    minInvestmentAmount: _get(res, "minimumInvestmentAmount", null),
    minimumAdditionalInvestAmount: _get(
      res,
      "minimumAdditionalInvestAmount",
      null,
    ),
    investmentTenure: _get(res, "investmentDuration", null),
    investmentStrategy: _get(res, "investmentStrategy", null),
    isPaymentCompleted: _get(res, "paymentStatus", 0),
    portfolioGeneratedDate: _get(res, "portfolioGeneratedDate", null),
    expiryDate: _get(res, "expiryDate", null),
    dateOfBirth: _get(res, "dob", null),
    pan: _get(res, "pancardNumber", null),
    planId: _get(res, "planId", null),
    hasOnboardingInvestmentDetailsConfirmed: _get(
      res,
      "hasOnboardingInvestmentDetailsConfirmed",
      0,
    ),
    customerSubscriptionId: _get(res, "customerSubscriptionId", null),
    isMobileVerified: _get(res, "isMobileVerified", null),
  };
};

jarvisPrimeOnboardingParser.submitRiskAssessmentQuestion = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  return {
    riskProfileId: _get(res, "riskProfileId", null),
    riskProfileName: _get(res, "riskProfileName", null),
  };
};

jarvisPrimeOnboardingParser.primeSubscription = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  return {
    customerSubscriptionId: _get(res, "customerSubscriptionId", null),
    gatewaySubscriptionId: _get(res, "gatewaySubscriptionId", null),
    gateway: _get(res, "gateway", null),
  };
};

jarvisPrimeOnboardingParser.capturePrimeSubscription = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  return {
    subscriptionStatus: _get(res, "subscriptionStatus", null),
    customerSubscriptionId: _get(res, "customerSubscriptionId", null),
  };
};

jarvisPrimeOnboardingParser.initiateDocumentSigning = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  return {
    documentId: _get(res, "documentId", null),
    accessToken: _get(res, "accessToken", null),
    identifier: _get(res, "documentIdentifier", null),
    gateway: _get(res, "signingGateway", null),
  };
};

jarvisPrimeOnboardingParser.portfolioData = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  const parsePortfolio = (portfolio) =>
    portfolio.map((p) => ({
      allocation: _get(p, "allocation", null),
      symbol: _get(p, "symbol", null),
      stockQuantity: _get(p, "stockQuantity", null),
      stockName: _get(p, "stockName", null),
      currentValue: _get(p, "currentValue", null),
      sector: _get(p, "sector", null),
      marketCap: _get(p, "marketCap", null),
    }));

  const parseMarketBreakup = (market) =>
    market.map((m) => ({
      label: _get(m, "cap", null),
      value: _get(m, "value", null),
    }));

  const parseSectorBreakup = (sector) =>
    sector.map((m) => ({
      label: _get(m, "sector", null),
      value: _get(m, "value", null),
    }));

  return {
    portfolioData: parsePortfolio(_get(res, "portfolio", [])),
    marketBreakupData: parseMarketBreakup(_get(res, "marketBreakup", [])),
    sectorBreakupData: parseSectorBreakup(_get(res, "sectorBreakup", [])),
  };
};

jarvisPrimeOnboardingParser.pricingData = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  return {
    investmentAmount: _get(res, "investmentAmount", null),
    feesPercentage: _get(res, "halfYearlyFeesPercentage", null),
    feesGSTPercentage: _get(res, "gstPercentage", null),
    feesTenure: _get(res, "feesTenure", null),
    fees: _get(res, "halfYearlyFees", null),
    feesGST: _get(res, "halfYearlyFeesGst", null),
    feesTotal: _get(res, "halfYearlyFeesTotal", null),
    discountedAmount: _get(res, "discountedAmount", null),
    discountedPercentage: _get(res, "discountedPercentage", null),
  };
};

jarvisPrimeOnboardingParser.sendEmailVerificationLink = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (!res) {
    return {};
  }

  return {
    message: _get(res, "message", ""),
    magicLink: _get(res, "result.magicLink", ""),
  };
};

export { jarvisPrimeOnboardingParser };
